import { render, staticRenderFns } from "./PwdEdit.vue?vue&type=template&id=488eee6c&scoped=true&"
import script from "./PwdEdit.vue?vue&type=script&lang=js&"
export * from "./PwdEdit.vue?vue&type=script&lang=js&"
import style0 from "./PwdEdit.vue?vue&type=style&index=0&id=488eee6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488eee6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('488eee6c')) {
      api.createRecord('488eee6c', component.options)
    } else {
      api.reload('488eee6c', component.options)
    }
    module.hot.accept("./PwdEdit.vue?vue&type=template&id=488eee6c&scoped=true&", function () {
      api.rerender('488eee6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/PwdEdit.vue"
export default component.exports